/* unplugin-vue-components disabled */var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "mine-cell",
    class: {
      border: !_vm.hiddenBorder
    }
  }, [!_vm.hasTitleSlot ? _c('div', [_vm._v(" " + _vm._s(_vm.title) + " ")]) : _vm._e(), _vm.hasTitleSlot ? _c('div', [_vm._t("title")], 2) : _vm._e(), _c('div', {
    staticClass: "upload"
  }, [_vm.showUploadList ? _vm._l(_vm.currValue, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "upload-list",
      on: {
        "click": function ($event) {
          return _vm.show(index);
        }
      }
    }, [_c('img', {
      staticClass: "img",
      attrs: {
        "src": item
      }
    }), _c('div', {
      staticClass: "upload-list-delete",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.deleteImg(index);
        }
      }
    }, [_c('img', {
      staticClass: "img",
      attrs: {
        "src": "/spa_static_mobile/icon/deletepic28_28@3x.png"
      }
    })])]);
  }) : _vm._e(), _c('div', {
    class: {
      'upload-list': _vm.showAddImg,
      'upload-btn': _vm.showAddImg
    },
    on: {
      "click": _vm.clickUpload
    }
  }, [_vm._t("default", function () {
    return [_vm._m(0)];
  })], 2), _c('Previewer', {
    ref: "previewer",
    attrs: {
      "list": _vm.imgUrlsForPreviewer
    }
  })], 2)]);
};
var staticRenderFns = [function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "default-add"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": "/spa_static_mobile/icon/addpic40_40@3x.png"
    }
  })]);
}];
export { render, staticRenderFns };